import CustomerList from "./manageUsers/userList";
import CustomerTopbar from "./manageUsers/topbar";
import manageproducts from "./productManagement/manageProducts";
import ManageInventory from "./productManagement/manageInventory";
import addProduct from "./productManagement/addProduct";
import editProduct from "./productManagement/editProduct";
import ViewProduct from "./productManagement/viewProduct";
import OrderManagement from "./orderManagement/order";
import DiscountCoupon from "./DiscountAndCoupon/discountCoupon";
import AddProduct from "./DiscountAndCoupon/add";
import viewDiscount from "./DiscountAndCoupon/view";
import EditDiscount from "./DiscountAndCoupon/edit";
import Revenue from "./manage-revenue";
import Ratings from "./ratings";
import CustomerSupport from "./customer-support";
import Chat from "./chat";
import Subscription from "./subscription-plans";
import Support from "./SupportCenter";
import Settings from "./settings";
import AddCampaign from "./DiscountAndCoupon/add";
import ViewOrderManagement from "./orderManagement/view";

/* eslint-disable import/no-anonymous-default-export */
export default {
  CustomerTopbar,
  CustomerList,
  manageproducts,
  ManageInventory,
  addProduct,
  editProduct,
  ViewProduct,
  OrderManagement,
  DiscountCoupon,
  AddProduct,
  viewDiscount,
  EditDiscount,
  Revenue,
  Ratings,
  CustomerSupport,
  Chat,
  Subscription,
  Support,
  ViewOrderManagement,
  Settings,
  AddCampaign





};
